export default function setLocaleOnContainer(element, locale) {
  if (element && locale.language) {
    element.setAttribute('lang', locale.validLocale)
  }
}
